// src/app/pages/home/home.ts
import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
// import { LocationWorldMapComponent } from '../location-world-map/location-world-map';

type Tier = 't0' | 't3' | 't6';

@Component({
  selector: 'app-home',
  standalone: true,
  imports: [RouterModule],
  templateUrl: './home.html'
})
export class homeComponent {
  private allowedTiers: Tier[] = this.readAllowedTiers();

  get showT0(): boolean {
    return this.allowedTiers.includes('t0');
  }

  get showT3(): boolean {
    return this.allowedTiers.includes('t3');
  }

  get showT6(): boolean {
    return this.allowedTiers.includes('t6');
  }

  private readAllowedTiers(): Tier[] {
    try {
      const raw = sessionStorage.getItem('allowedTiersFromMe');
      const parsed = raw ? JSON.parse(raw) : [];
      const arr = Array.isArray(parsed) ? parsed : [];
      return arr
        .map((x: any) => String(x).trim().toLowerCase())
        .filter((x: string) => x === 't0' || x === 't3' || x === 't6') as Tier[];
    } catch {
      return [];
    }
  }
}